import { Component, OnInit } from '@angular/core';
import { EditSplitMergeService } from 'app/services/edit-split-merge.service';

@Component({
  selector: 'app-tool-line-merge',
  templateUrl: './tool-line-merge.component.html',
  styleUrls: ['./tool-line-merge.component.css']
})
export class ToolLineMergeComponent implements OnInit {

	constructor(
		private splitService: EditSplitMergeService
	) { }

	clickMerge() {
		let data = this.splitService.mergeToolBS.getValue();
		let action = data ? data.action : 'stop';
		if (action === 'stop') {
			action = 'start';
		} else {
			action = 'stop';
		}
		this.splitService.mergeToolBS.next({
			action: action
		});
	}
	ngOnInit() {
	}

}
